<template>
  <div class="survey-card-component" :class="$attrs.class">
    <header>
      <slot name="header" />
    </header>
    <article>
      <main>
        <slot name="main" />
      </main>
      <footer>
        <slot name="footer" />
      </footer>
    </article>
  </div>
</template>

<style lang="scss">
  .survey-card-component {
    width: 100%;

    > header {
      display: flex;
      align-items: center;
      transform: translateY(50%);

      > img {
        margin-left: 10px;
      }

      > section {
        padding: 15px;
        min-width: 1px;

        h4 {
          margin: 0 0 15px;
          line-height: 1.25;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        p {
          margin: 0;
          color: $primary-lighter;
          font-size: 18px;
          line-height: 1.25;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }

    > article {
      padding-top: 40px;
      border-radius: 4px;
      background-color: white;
      box-shadow: $card-shadow;

      > main {
        padding: 15px 25px;
        min-height: 80px;
        display: flex;
        justify-content: center;
        flex-direction: column;

        h5,
        h4 {
          margin: 0;
          line-height: 1.25;
        }
      }

      > footer {
        padding: 0 15px 15px;
        display: flex;
        justify-content: space-around;

        .q-btn {
          font-size: 18px;
          line-height: 1.2;
          height: 65px;
          width: calc(50% - 7.5px);

          @media screen and (max-width: 320px) {
            font-size: 16px;
          }
        }
      }
    }
  }
</style>
